import { Link } from 'react-router-dom';
import { Button, buttonVariants } from '@shared/ui';
import { useAuth } from '@entities/auth';

export const Hero = () => {
  const { user } = useAuth();

  return (
    <section
      className="container grid place-items-center gap-10 py-20 md:py-32 lg:grid-cols-2"
      id="home"
    >
      <div className="space-y-6 self-end text-center lg:text-start">
        <main className="text-5xl font-bold md:text-6xl">
          <h2 className="inline">
            <span className="bg-gradient-to-b from-primary/60 to-primary bg-clip-text text-transparent">
              Welcome
            </span>{' '}
            to
          </h2>{' '}
          <h2 className="inline">
            <span className="inline bg-gradient-to-r from-[#61DAFB] via-[#4c92fe] to-[#0164FD] bg-clip-text text-transparent">
              Eclipse Fitness
            </span>{' '}
          </h2>
        </main>
        <p className="mx-auto text-xl text-muted-foreground md:w-10/12 lg:mx-0">
          A passionate fitness community located in Las Vegas, Nevada here to
          support individuals of all fitness levels and backgrounds.
        </p>
        <div className="space-y-4 md:space-x-4 md:space-y-0">
          <Link to="/register" rel="noreferrer noopener">
            <Button className="w-full md:w-1/3">SIGN UP</Button>
          </Link>
          <Link
            rel="noreferrer noopener"
            to="/login"
            className={`w-full md:w-1/3 ${buttonVariants({
              variant: 'outline',
            })}`}
          >
            {user !== null ? 'TO DASHBOARD' : 'LOGIN'}
          </Link>
        </div>
      </div>
    </section>
  );
};
